// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "title-2OlFj";
var _4 = "content-2U-NR";
var _5 = "upsaleItem-y7KP9";
export { _1 as "__esModule", _2 as "mobile", _3 as "title", _4 as "content", _5 as "upsaleItem" }
export default { "__esModule": _1, "mobile": _2, "title": _3, "content": _4, "upsaleItem": _5 }
